import { render, staticRenderFns } from "./CompanyCaseList.vue?vue&type=template&id=d5474164"
import script from "./CompanyCaseList.vue?vue&type=script&lang=js"
export * from "./CompanyCaseList.vue?vue&type=script&lang=js"
import style0 from "./CompanyCaseList.vue?vue&type=style&index=0&id=d5474164&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports